import cx from 'classnames';
import { Text } from 'platform-components';
import React from 'react';

import { getMesHost } from 'utils/external-lms/external-lms';

import { LibraryBreadcrumbLink } from '../__link/breadcrumb__link';

interface Props {
    mix?: string;
}

export const LibraryBreadcrumbMes = ({ mix }: Props) => {
    return (
        <div className={cx('library-breadcrumb', mix)}>
            <LibraryBreadcrumbLink isRouter={false} to={getMesHost()}>
                <Text id="library.returnToMes" size={Text.SIZE.XL} weight={Text.WEIGHT.M} />
            </LibraryBreadcrumbLink>
        </div>
    );
};
